import React, {useState} from "react";
import PropTypes from "prop-types";
import {getMediaThumbSrc} from "../../helpers/mediaUrl";
import {Link} from "react-router-dom";
import useFunction from "../../hooks/useFunction";
import Button from "../Button/Button";


const ITEMS_PER_PAGE = 5

const LocationHistory = (props) => {

  const {locationHistory} = props
  const {date} = useFunction()
  const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE)

  if (!locationHistory || locationHistory.length === 0) {
    return null
  }

  const formatDateRange = (entry) => {
    const parts = []
    if (entry.date_from) parts.push(date(entry.date_from))
    if (entry.date_to) parts.push(date(entry.date_to))
    return parts.length === 2 ? parts[0] + ' - ' + parts[1] : parts[0] || null
  }

  const visibleEntries = locationHistory.slice(0, visibleCount)
  const hasMore = locationHistory.length > visibleCount

  return (
    <div className="component-location-history">
      <h3>Waar geweest</h3>
      <div className="history-grid">
        {visibleEntries.map((entry, i) => {
          const thumbSrc = getMediaThumbSrc(entry.media)
          const dateRange = formatDateRange(entry)
          const hasSpotGroupLink = entry.spot_group && entry.spot_group.slug

          return (
            <div key={entry.id || i} className="history-card">
              {thumbSrc &&
                <div className="history-card-image">
                  <img src={thumbSrc} alt={entry.label} loading="lazy"/>
                </div>
              }
              <div className="history-card-content">
                <div className="history-title-row">
                  <h4>
                    {hasSpotGroupLink
                      ? <Link to={'/locatie/' + entry.spot_group.slug}>{entry.label}</Link>
                      : entry.label
                    }
                  </h4>
                  {entry.source === 'booking' &&
                    <span className="history-badge">Via boeking</span>
                  }
                </div>
                {entry.city &&
                  <p className="history-city">{entry.city}</p>
                }
                {dateRange &&
                  <p className="history-dates">{dateRange}</p>
                }
                {entry.description &&
                  <p className="history-description">{entry.description}</p>
                }
              </div>
            </div>
          )
        })}
      </div>
      {hasMore &&
        <div className="history-show-more">
          <Button
            label={'Toon meer (' + (locationHistory.length - visibleCount) + ')'}
            size="s"
            color="grey-ghost"
            onClick={() => setVisibleCount(prev => prev + ITEMS_PER_PAGE)}
          />
        </div>
      }
    </div>
  )
}

LocationHistory.propTypes = {
  locationHistory: PropTypes.array.isRequired,
}

export default LocationHistory
